import { ChangeDetectorRef, Component, Inject, OnDestroy } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';
import { StageConfig } from 'collage-designer/stage/stage-config';
import { StageService } from 'collage-designer/stage/stage.service';
import { AsyncEventEmitterSubscriber } from 'core/utils/async-event-emitter';
import { Subscription } from 'rxjs';
import { ToolboxComponent } from '../toolbox.component';
import { ToolboxService, } from '../toolbox.service';


@Component({
    selector: 'preview-toolbox',
    templateUrl: './preview-toolbox.component.html',
    styleUrls: ['../toolbox.component.scss',],
    standalone: false
})
export class PreviewToolboxComponent extends ToolboxComponent
    implements OnDestroy
{
  public stageID: string | undefined;
  public previewType: string | undefined;

  private subscriptions: Subscription = new Subscription();
  private stageConfigChangedSubscription:
      AsyncEventEmitterSubscriber<StageConfig>;
  private stageConfigAppliedSubscription:
      AsyncEventEmitterSubscriber<boolean>;

  constructor(
      private cdr: ChangeDetectorRef,
      mir: MatIconRegistry,
      sanitizer: DomSanitizer,
      @Inject(ToolboxService) toolboxService,
      @Inject(DesignStepService) private designStepService: DesignStepService,
      @Inject(StageService) private stageService: StageService)
  {
    super(mir, sanitizer, toolboxService);

    this.loadIcon('preview');

    this.stageConfigAppliedSubscription =
        this.stageService.stageConfigApplied.subscribe(async () => {
          this.setPreviewParams();
          this.cdr.detectChanges();
        });
    this.subscriptions.add(
        this.toolboxService.placeholderChanged.subscribe(() => {
          this.setPreviewParams();
          this.cdr.detectChanges();
        }));
    this.stageConfigChangedSubscription =
        this.stageService.stageConfigChanged.subscribe(async (_) => {
          this.setPreviewParams();
          this.cdr.detectChanges();
        });
    this.setPreviewParams();
  }

  public ngOnDestroy(): void
  {
    this.subscriptions.unsubscribe();
    this.stageService.stageConfigChanged.unsubscribe(
        this.stageConfigChangedSubscription);
    this.stageService.stageConfigApplied.unsubscribe(
        this.stageConfigAppliedSubscription);
  }

  private setPreviewParams(): void
  {
    this.stageID = this.getStageID();
    this.previewType = this.getPreviewType();
  }

  private getStageID(): string | undefined
  {
    const stageReference = this.stageService.getCurrentStageReference();

    return stageReference ? stageReference.attr('id') : undefined;
  }

  private getPreviewType(): string | undefined
  {
    return this.designStepService.getPart().previewType;
  }
}
